<template>
  <div class="study_type_manage">
    <el-divider content-position="left">云上公司注册文章分类管理</el-divider>
    <el-row>
      <el-col :span="24" class="tr" style="margin-bottom: 0.2rem">
        <el-button type="primary" size="mini" @click="handleAddOpen">添加</el-button>
      </el-col>
    </el-row>
    <el-tabs v-model="miniProtype" @tab-click="handleClick">
      <el-tab-pane label="抖音小程序" name="first"></el-tab-pane>
      <el-tab-pane label="支付宝小程序" name="second"></el-tab-pane>
      <el-tab-pane label="微信小程序" name="third"></el-tab-pane>
    </el-tabs>
    <el-table height="calc(100vh - 316px)" :data="pageData" size="medium" style="width: 100%" border>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
      >
      </el-table-column>
      <el-table-column label="分类图标" prop="cate_icon">
        <template slot-scope="scope">
          <div style="cursor: pointer; width: 100%">
            <span
              @click="handlePictureCardPreviewS(scope.row.cate_icon)"
              style="color: #409eff"
              >{{ scope.row.cate_icon }}</span
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="130">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-dialog
      title="添加分类"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleAddClose"
    >
      <div>
        <el-row class="mb-10">
          <el-input
            placeholder="请输入分类名称"
            v-model="addData.cate_name"
            size="small"
            clearable
          >
          </el-input>
        </el-row>
        <el-row class="mb-10">
          <el-upload
            class="upload-demo"
            :headers="uploadHeader"
            :action="actionHost + '/api/article/banner/upload_ccrmp'"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="materialFileList"
            list-type="picture"
            :on-success="handleAddCoverSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-button v-if="!addCoverUrl" size="mini" type="primary">点击上传</el-button>
            <div slot="tip" v-if="false" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleAddClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑分类"
      :visible.sync="editVisible"
      width="30%"
      :before-close="handleEditClose"
    >
      <div>
        <el-row class="mb-10">
          <el-input
            placeholder="请输入分类名"
            v-model="editData.cate_name"
            size="small"
            clearable
          >
          </el-input>
        </el-row>
        <el-row class="mb-10">
          <el-upload
            class="upload-demo"
            :headers="uploadHeader"
            :action="actionHost + '/api/article/banner/upload_ccrmp'"
            :on-preview="handleSavePictureCardPreview"
            :on-remove="handleSaveRemove"
            :file-list="materialFileListSave"
            list-type="picture"
            :on-success="handleSaveCoverSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-button v-if="!editCoverUrl" size="mini" type="primary"
              >点击上传</el-button
            >
            <div slot="tip" v-if="false" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleEditClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="10%" :visible.sync="dialogVisibleShowImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "study_type_manage",
  data() {
    return {
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      category: [],
      miniProtype: "first",
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      col: [
        {
          label: "id",
          prop: "cate_id",
        },
        {
          label: "分类名称",
          prop: "cate_name",
        },
      ],
      needDeleteId: "",
      needType: 1,
      dialogVisible: false,
      editVisible: false,
      addData: {
        cate_name: "",
        cate_icon: "",
      },
      editData: {
        cate_id: null,
        index: null,
        cate_name: "",
        cate_icon: "",
        cate_icon_name: "",
      },
      addCoverUrl: "",
      editCoverUrl: "",
      dialogVisibleShowImg: false,
      dialogImageUrl: "",
      materialFileList: [],
      materialFileListSave: [],
    };
  },
  computed: {
    actionHost: {
      get: function () {
        // http://192.168.1.110
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    pageData: {
      get: function () {
        return this.category.slice(
          this.pageOption.pageSize * (this.pageOption.currentPage - 1),
          this.pageOption.pageSize * this.pageOption.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    handleAddCoverSuccess(res, file) {
      if (res.code === 0) {
        this.addCoverUrl = URL.createObjectURL(file.raw);
        this.materialFileList.push({
          name: file.name,
          // url: this.imgPath + res.data.store_result,
          url: res.data.oss_path,
          img_name: res.data.oss_path,
          // img_name: res.oss_path,
        });
        // this.addData.cate_icon = this.imgPath + res.data.store_result
        this.addData.cate_icon = res.data.store_result;
        // this.addData.cate_icon = res.data.oss_path
        this.addData.cate_icon_name = res.data.store_result;
        // this.addData.cate_icon_name = res.data.oss_path
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSaveCoverSuccess(res, file) {
      if (res.code === 0) {
        this.editCoverUrl = URL.createObjectURL(file.raw);
        this.materialFileListSave.push({
          name: file.name,
          // url: this.imgPath + res.data.store_result,
          // url: res.data.store_result,
          // img_name: res.data.store_result,
          url: res.data.oss_path,
          img_name: res.oss_path,
        });
        this.editData.cate_icon_name = res.data.store_result;
        // this.editData.cate_icon_name = res.data.oss_path
        // this.editData.cate_icon = this.imgPath + res.data.store_result
        this.editData.cate_icon = res.data.store_result;
        // this.editData.cate_icon = res.data.oss_path
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.error("封面只能是 JPG、PNG 格式!");
        return false;
      }
      return true;
    },
    handleRemove(file) {
      if (file.name === this.materialFileList[0].name) {
        var fileName = this.materialFileList[0].img_name;
        this.addCoverUrl = "";
        this.addData.cate_icon = "";
        this.materialFileList = [];
      }
      this.$axios
        .post("/api/article/banner/delete", { file_name: fileName })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handlePictureCardPreviewS(url) {
      this.dialogImageUrl = url;
      this.dialogVisibleShowImg = true;
    },
    handlePictureCardPreview(url) {},
    handleSaveRemove(file) {
      if (file.name === this.materialFileListSave[0].name) {
        var fileName = this.materialFileListSave[0].img_name;
        this.editCoverUrl = "";
        this.editData.cate_icon = "";
        this.materialFileListSave = [];
      }
      this.$axios
        .post("/api/article/banner/delete_ccrmp", {
          file_name: fileName,
          id: this.needDeleteId,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            this.$message.success(data.msg);
            this.getCategory();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleSavePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
    },
    handleClick(val) {
      if (val.name === "first") {
        this.npage = 1;
        this.needType = 1;
        this.getCategory();
      }
      if (val.name === "second") {
        this.npage = 1;
        this.needType = 2;
        this.getCategory(2);
      }
      if (val.name === "third") {
        this.needType = 3;
        this.npage = 1;
        this.getCategory(3);
      }
    },
    getCategory(type = 1) {
      this.$axios
        .get("/api/common/study/study_list", {
          params: {
            type,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.category = data.data;
            for (var a = 0; a < data.data.length; a++) {
              // if (this.category[a].cate_icon) {
              if (this.category[a].oss_path) {
                // this.category[a].cate_icon_name = this.category[a].cate_icon
                this.category[a].cate_icon_name = this.category[a].oss_path;
                this.category[a].cate_icon =
                  // this.imgPath + this.category[a].cate_icon
                  this.category[a].oss_path;
              }
            }
            this.pageOption.total = this.category.length;
          }
        });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
    },
    handleAddOpen() {
      this.dialogVisible = true;
    },
    handleAdd() {
      // console.log(this.addData)
      if (!this.addData.cate_name) {
        this.$message.error("请输入分类名！");
        return;
      }
      if (!this.addData.cate_icon) {
        this.$message.error("请上传图标！");
        return;
      }
      this.$axios
        .post("/api/common/study/create", {
          cate_name: this.addData.cate_name,
          cate_icon: this.addData.cate_icon,
          type: this.needType,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.category.push(data.data);
            data.data.cate_icon_name = data.data.cate_icon;
            // data.data.cate_icon = this.imgPath + data.data.cate_icon
            // data.data.cate_icon = data.data.cate_icon
            this.getCategory(this.needType);
            // console.log(data.data)
            this.handleAddClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleAddClose() {
      this.addData.cate_name = "";
      this.addData.cate_icon = "";
      this.addCoverUrl = "";
      this.materialFileList = [];
      this.dialogVisible = false;
    },
    handleEdit(index, row) {
      this.editData.cate_id = row.cate_id;
      this.editData.index = index;
      this.editData.cate_name = row.cate_name;
      this.editData.cate_icon = row.cate_icon;
      this.editData.cate_icon_name = row.cate_icon_name;
      this.needDeleteId = row.cate_id;
      if (row.cate_icon) {
        this.materialFileListSave.push({
          name: row.cate_icon_name,
          url: row.cate_icon,
          img_name: row.cate_icon_name,
        });
      }
      // console.log(row.cate_icon_name)
      if (row.cate_icon_name) {
        this.materialFileListSave[0].img_name = row.cate_icon_name;
      }
      this.editCoverUrl = row.cate_icon;
      this.editVisible = true;
    },
    handleSave() {
      if (!this.editData.cate_id) {
        this.$message.error("请求错误！");
        return;
      }
      if (!this.editData.cate_name) {
        this.$message.error("请输入分类名！");
        return;
      }
      if (!this.editData.cate_icon) {
        this.$message.error("请上传分类图标");
        return;
      }
      this.$axios
        .post("/api/common/study/update/" + this.editData.cate_id, {
          cate_name: this.editData.cate_name,
          cate_icon: this.editData.cate_icon,
          type: this.needType,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let idx =
              this.pageOption.pageSize * (this.pageOption.currentPage - 1) +
              this.editData.index;
            this.category[idx].cate_name = this.editData.cate_name;
            // this.category[idx].cate_icon = this.editData.cate_icon
            this.category[idx].cate_icon = data.data.oss_path;
            this.category[idx].cate_icon_name = this.editData.cate_icon_name;
            this.handleEditClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleEditClose() {
      this.needDeleteId = "";
      this.editData.id = null;
      this.editData.index = null;
      this.editData.cate_name = "";
      this.editData.cate_icon = "";
      this.editData.cate_icon_name = "";
      this.materialFileListSave = [];
      this.editVisible = false;
    },
  },
  mounted() {
    this.getCategory();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

.study_type_manage {
  marginLeft();
}

.study_type_manage >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.mb-10 {
  margin-bottom: 0.2rem;
  margin-top: 0.4rem;
}

.m-label {
  line-height: 0.64rem;
}

.tr {
  text-align: right;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/studyPlatfrom/study_type_manage_common.vue